import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store/store';
import App from './App';
import 'sanitize.css';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { HTML_LANG, META_DESCRIPTION, lang } from './utils/i18n';

// Reflect the hostname-detected language on <html lang> (sv-SE by default in index.html)
document.documentElement.lang = HTML_LANG[lang()];

// Localise the meta description too (index.html ships the Swedish one)
var descEl = document.querySelector('meta[name="Description"]');
if (descEl) descEl.setAttribute('content', META_DESCRIPTION[lang()]);

// Capture beforeinstallprompt early, before React mounts
window.addEventListener('beforeinstallprompt', function (e) {
  e.preventDefault();
  (window as any).__deferredInstallPrompt = e;
});

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
serviceWorker.register();
// Learn more about service workers: https://bit.ly/CRA-PWA
